
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CheckmarkIcon',
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  }
});
